export default "__VITE_ASSET__Dd15MZTd__"